import React, { useState } from "react";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import './Adicionaradm.css';


const HEADER_HEIGHT = 56;

const Adicionaradm = ({ onProximo }) => {
    const { useNavigate } = require('react-router-dom');
    const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [novoAdmin, setNovoAdmin] = useState('');
  const [novoNumero, setNovoNumero] = useState('');
  const [adminAdicionado, setAdminAdicionado] = useState(null);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
              ? 220
              : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
              ? 220
              : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
              ? 220
              : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (
            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} />
            </a>
          ) : (
            <a href="/app">
              <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} />
            </a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12, color: "#fff" }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Projetos</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Projetos" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-folder2-open" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Meus Projetos</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Contas" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-send" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Disparo 1x1</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-robot" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Mudar Nome</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "6px 16px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <a className="dropdown-item" href="#">Perfil</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">Configurações</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de campanha */}
      <div
        style={{
          marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
          paddingTop: HEADER_HEIGHT,
          width: window.innerWidth > 768
            ? sidebarOpen
              ? "calc(100% - 220px)"
              : "calc(100% - 70px)"
            : "100vw",
          transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
          minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
          background: '#f7f7f7',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <button
          style={{
            background: '#51a197',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '14px 32px',
            fontWeight: 'bold',
            fontSize: 20,
            marginTop: 48,
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(81,161,151,0.10)',
            transition: 'background 0.2s',
          }}
          onClick={() => setModalAberto(true)}
        >
          Adicionar novo administrador
        </button>
        {modalAberto && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.35)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 340, boxShadow: '0 4px 32px rgba(0,0,0,0.18)' }}>
              <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 18, color: '#005c53' }}>Adicionar novo administrador ao grupo</div>
              <input
                type="text"
                placeholder="Nome do novo administrador"
                value={novoAdmin}
                onChange={e => setNovoAdmin(e.target.value)}
                style={{
                  width: '100%',
                  padding: 12,
                  fontSize: 18,
                  border: '1px solid #ccc',
                  borderRadius: 8,
                  outline: 'none',
                  background: 'white',
                  marginBottom: 12,
                  color: '#222',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                }}
              />
              <input
                type="tel"
                placeholder="Número do administrador (ex: 11999999999)"
                value={novoNumero}
                onChange={e => {
                  let v = e.target.value.replace(/\D/g, '');
                  if (v.length > 11) v = v.slice(0, 11);
                  setNovoNumero(v.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3'));
                }}
                style={{
                  width: '100%',
                  padding: 12,
                  fontSize: 18,
                  border: '1px solid #ccc',
                  borderRadius: 8,
                  outline: 'none',
                  background: 'white',
                  marginBottom: 18,
                  color: '#222',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                }}
                maxLength={15}
              />
              <div style={{ display: 'flex', gap: 16, justifyContent: 'flex-end' }}>
                <button onClick={() => setModalAberto(false)} style={{ padding: '8px 24px', borderRadius: 8, border: 'none', background: '#ccc', color: '#222', fontWeight: 500, cursor: 'pointer' }}>Cancelar</button>
                <button
                  onClick={() => {
                    if (novoAdmin.trim() && novoNumero.trim()) {
                      setAdminAdicionado({ nome: novoAdmin.trim(), numero: novoNumero.trim() });
                      setModalAberto(false);
                      setNovoAdmin('');
                      setNovoNumero('');
                    }
                  }}
                  style={{ padding: '8px 24px', borderRadius: 8, border: 'none', background: '#51a197', color: '#fff', fontWeight: 600, cursor: 'pointer' }}
                  disabled={!novoAdmin.trim() || !novoNumero.trim()}
                >Adicionar</button>
              </div>
            </div>
          </div>
        )}
        {adminAdicionado && (
          <div style={{
            marginTop: 32,
            background: '#f0f4f8',
            borderRadius: 12,
            padding: 24,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 12,
            maxWidth: 400,
          }}>
            <div style={{ fontWeight: 'bold', fontSize: 18, color: '#005c53' }}>Administrador adicionado:</div>
            <div style={{ fontSize: 17, color: '#222' }}>Nome: {adminAdicionado.nome}</div>
            <div style={{ fontSize: 17, color: '#222' }}>Número: {adminAdicionado.numero}</div>
            <button
              style={{
                marginTop: 12,
                background: '#e74c3c',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 24px',
                fontWeight: 'bold',
                fontSize: 16,
                cursor: 'pointer',
              }}
              onClick={() => setAdminAdicionado(null)}
            >Excluir administrador</button>
          </div>
        )}
        <button
          style={{
            background: '#005c53',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '10px 28px',
            fontWeight: 'bold',
            fontSize: 18,
            marginTop: 32,
            cursor: 'pointer',
            transition: 'opacity 0.2s',
          }}
          onClick={() => {
            if (adminAdicionado) {
              onProximo && onProximo({ nome: adminAdicionado.nome, numero: adminAdicionado.numero });
            } else {
              alert('Adicione um administrador antes de prosseguir.');
            }
          }}
        >
          Próximo
        </button>
      </div>
    </div>
  );
};

export default Adicionaradm;